import { type TimeSlot } from "@src/appV2/redesign/Shift/types";

export interface ShiftTime {
  start: Date;
  end: Date;
}

export const APPLY_TO_OPTIONS = {
  THIS_SHIFT_ONLY: "thisShiftOnly",
  THIS_AND_FOLLOWING: "thisAndFollowing",
  ALL_SHIFTS: "allShifts",
} as const;

export type ApplyToOption = (typeof APPLY_TO_OPTIONS)[keyof typeof APPLY_TO_OPTIONS];

export interface EditTimeResult {
  start: Date;
  end: Date;
  applyTo: ApplyToOption;
  /** When the start time falls outside the original time slot, this contains the new slot. */
  newTimeSlot?: TimeSlot;
}

export interface TimeValidationError {
  field: "start" | "end" | "duration";
  message: string;
}

/**
 * Time slot boundaries for validation.
 * AM: 12:00 AM - 11:59 AM (0:00 - 11:59)
 * PM: 11:00 AM - 10:59 PM (11:00 - 22:59)
 * NOC: 5:00 PM - 5:59 AM (+1 day) (17:00 - 5:59)
 */
export const TIME_SLOT_BOUNDARIES: Record<
  TimeSlot,
  { startMin: number; startMax: number; crossesMidnight?: boolean }
> = {
  am: { startMin: 0, startMax: 11 },
  pm: { startMin: 11, startMax: 22 },
  noc: { startMin: 17, startMax: 5, crossesMidnight: true },
};
